/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero__InstructionsInputs */

const en_home_hero__instructions = /** @type {(inputs: Home_Hero__InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is directed at the reader, translate it informally.`)
};

/**
* | output |
* | --- |
* | "This is directed at the reader, translate it informally." |
*
* @param {Home_Hero__InstructionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_hero__instructions = /** @type {((inputs?: Home_Hero__InstructionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero__InstructionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero__instructions(inputs)
});